import React from 'react';
import { getAllUserBoards } from '../helpers/data/boardData';
import BoardsCard from '../components/Cards/BoardsCard';
import Loader from '../components/Loader';
import getUid from '../helpers/data/authData';
import BoardForm from '../components/Forms/boardsForm';
import AppModal from '../components/AppModal';

export default class Boards extends React.Component {
  state = {
    boards: [],
    loading: true
  };

  componentDidMount() {
    this.getBoards();
  }

  getBoards = () => {
    const currentUserId = getUid();
    getAllUserBoards(currentUserId).then(response => {
      this.setState(
        {
          boards: response
        },
        this.setLoading
      );
    });
  };

  setLoading = () => {
    this.timer = setInterval(() => {
      this.setState({ loading: false });
    }, 1000);
  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { boards, loading } = this.state;
    const showBoards = () =>
      boards.map(board => (
        <BoardsCard
          key={board.firebaseKey}
          board={board}
          redrawDom={this.getBoards}
        />
      ));
    return (
      <>
        {loading ? (
          <Loader />
        ) : (
          <>
            <AppModal title={'Create Board'} buttonLabel={'Create Board'}>
              <BoardForm board={boards} onUpdate={this.getBoards} />
            </AppModal>

            <h2>Here are all of your boards</h2>
            <div className="d-flex flex-wrap container">
              {boards && showBoards()}
            </div>
          </>
        )}
      </>
    );
  }
}
